/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
const User = require('../user/user');
const MarginType = require('./margin_type');
const BulkTicket = require('../bulk_ticket2').default;
const FreeeCompany = require('../freee_company').default;
const OrganizationBillReceiver = require('./organization_bill_receiver').default;
const ArrangementRequestSetting = require('./arrangement_request_setting').default;
const ShinkansenLimitType = require('./shinkansen_limit_type').default;
const RentalCarLimitType = require('./rental_car_limit_type').default;

class Organization {
  static initClass() {
    this.revenueReferenceDateTypes = {
      confirmed_at: '予約確定日',
      end_date: '出張完了日'
    };

    this.orientations = {
      trip: '出張予約',
      expenses: '経費精算'
    };
  }

  constructor(args) {
    if (args == null) {
      args = {};
    }
    _.assign(this, args);
    this.members = _.map(args.members || [], m => new User(m));
    this.margin_types = _.map(args.margin_types || [], m => new MarginType(m));
    this.domestic_margin_type = _.find(this.margin_types, m => m.isDomestic()) || new MarginType();
    this.foreign_margin_type =
      _.find(this.margin_types, m => m.isForeign()) || new MarginType({ category: 'foreign' });
    this.bulkTickets = _.map(args.bulk_tickets || [], t => new BulkTicket(t));
    this.planId = args.plan_id;
    this.selectedFreeeCompanyId = args.selected_freee_company_id;
    this.freeeCompanies = args.freee_companies
      ? args.freee_companies.map(raw => new FreeeCompany(raw))
      : undefined;
    this.freeePartnerId = args.freee_partner_id;
    this.freeeMonthlyPriceSectionId = args.freee_monthly_price_section_id;
    this.isCreateFreeeTag = args.is_create_freee_tag;
    this.freeeDepartment = args.freee_department;
    this.ssoEnabled = args.sso_enabled;
    this.ssoEntityId = args.sso_entity_id;
    this.ssoUrl = args.sso_url;
    this.ssoLogoutUrl = args.sso_logout_url;
    this.ssoIdpCert = args.sso_idp_cert;
    this.enableRentalcarForm = args.enable_rentalcar_form;

    // for /admin/organizations
    this.amadeusCompanyName = args.amadeus_company_name;
    this.personInChargeName = args.person_in_charge_name;
    this.personInChargeEmail = args.person_in_charge_email;
    this.billingEmail = args.billing_email;
    this.bankAccountInfo = args.bank_account_info;
    this.agencyBankAccountInfo = args.agency_bank_account_info;
    this.memberCount = args.member_count;
    this.adminCount = args.admin_count;
    this.latestPlanName = args.latest_plan_name;
    this.showFee = args.show_fee;
    this.includeTax = args.include_tax;
    this.useBulkTicket = args.use_bulk_ticket;
    this.useKyuusyuuTicket = args.use_kyuusyuu_ticket;
    this.shinkansenLimitType = new ShinkansenLimitType(args.shinkansen_limit_type || {});
    this.rentalCarLimitType = new RentalCarLimitType(args.rental_car_limit_type || {});
    this.showEx = args.show_ex;
    this.domesticMarginType = _.find(this.margin_types, m => m.isDomestic()) || new MarginType();
    this.foreignMarginType =
      _.find(this.margin_types, m => m.isForeign()) || new MarginType({ category: 'foreign' });
    this.rakutenInnerFeeRate = args.rakuten_inner_fee_rate;
    this.exicAgencyFeeRate = args.exic_agency_fee_rate;
    this.revenueReferenceDateType = args.revenue_reference_date_type;
    this.expediaType = args.expedia_type;
    this.organizationBillReceivers = args.organization_bill_receivers
      ? _.map(args.organization_bill_receivers, r => new OrganizationBillReceiver(r))
      : [];
    this.arrangementRequestSetting = new ArrangementRequestSetting(args.arrangement_request_setting || {});
    this.requestFormApprovalRequired = args.request_form_approval_required;
    this.salesforceId = args.salesforce_id;
    this.salesforceImportId = args.salesforce_import_id;
    this.enterpriseIdentifactionNumber = args.enterprise_identification_number;
    this.invoiceDay = args.invoice_day;
    this.serviceId = args.service_id;
    this.dayOffOperation = args.day_off_operation;
    this.enableAutoStockCheck = args.enable_auto_stock_check;
    this.enableBatchApproval = args.enable_batch_approval;
    this.useSmartSearch = args.use_smart_search;
  }

  revenueReferenceDateTypeText() {
    return Organization.revenueReferenceDateTypes[this.revenue_reference_date_type];
  }

  orientationText() {
    return Organization.orientations[this.orientation];
  }

  ssoIdpCertSet() {
    return !_.isEmpty(this.ssoIdpCert);
  }

  setName(value) {
    this.name = value;
    return app.render();
  }

  setDomain(value) {
    this.domain = value;
    return app.render();
  }

  setUrl(value) {
    this.url = value;
    return app.render();
  }

  setAmadeusCompanyName(value) {
    this.amadeus_company_name = value;
    this.amadeusCompanyName = value;
    return app.render();
  }

  setAddress(value) {
    this.address = value;
    return app.render();
  }

  setTel(value) {
    this.tel = value;
    return app.render();
  }

  setPersonInChargeName(value) {
    this.person_in_charge_name = value;
    this.personInChargeName = value;
    return app.render();
  }

  setPersonInChargeEmail(value) {
    this.person_in_charge_email = value;
    this.personInChargeEmail = value;
    return app.render();
  }

  setBillingEmail(value) {
    this.billing_email = value;
    this.billingEmail = value;
    return app.render();
  }

  setBankAccountInfo(value) {
    this.bank_account_info = value;
    this.bankAccountInfo = value;
    return app.render();
  }

  setAgencyBankAccountInfo(value) {
    this.agency_bank_account_info = value;
    this.agencyBankAccountInfo = value;
    return app.render();
  }

  setDomesticBaseType(value) {
    this.domestic_margin_type.setBaseType(value);
    this.domesticMarginType.setBaseType(value);
    return app.render();
  }

  setDomesticBaseAmount(value) {
    this.domestic_margin_type.setBaseAmount(value);
    this.domesticMarginType.setBaseAmount(value);
    return app.render();
  }

  setForeignBaseType(value) {
    this.foreign_margin_type.setBaseType(value);
    this.foreignMarginType.setBaseType(value);
    return app.render();
  }

  setForeignBaseAmount(value) {
    this.foreign_margin_type.setBaseAmount(value);
    this.foreignMarginType.setBaseAmount(value);
    return app.render();
  }

  setPlanId(value) {
    this.plan_id = parseInt(value);
    return app.render();
  }

  setRakutenInnerFeeRate(value) {
    const num = parseInt(value);
    this.rakuten_inner_fee_rate = num || num === 0 ? num : '';
    this.rakutenInnerFeeRate = num || num === 0 ? num : '';
    return app.render();
  }

  setExicAgencyFeeRate(value) {
    const num = parseInt(value);
    this.exic_agency_fee_rate = num || num === 0 ? num : '';
    this.exicAgencyFeeRate = num || num === 0 ? num : '';
    return app.render();
  }

  setRevenueReferenceDateType(value) {
    this.revenue_reference_date_type = value;
    this.revenueReferenceDateType = value;
    return app.render();
  }

  setRequestFormApprovalRequired(value) {
    this.request_form_approval_required = value;
    this.requestFormApprovalRequired = value;
    return app.render();
  }

  setOrientation(value) {
    this.orientation = value;
    return app.render();
  }

  setInvoiceDay(value) {
    this.invoiceDay = value;
    return app.render();
  }

  toggleShowFee() {
    this.show_fee = !this.show_fee;
    this.showFee = !this.showFee;
    return app.render();
  }

  toggleIncludeTax() {
    this.include_tax = !this.include_tax;
    this.includeTax = !this.includeTax;
    return app.render();
  }

  toggleUseBulkTicket() {
    this.use_bulk_ticket = !this.use_bulk_ticket;
    this.useBulkTicket = !this.useBulkTicket;
    return app.render();
  }

  toggleUseKyuusyuuTicket() {
    this.use_kyuusyuu_ticket = !this.use_kyuusyuu_ticket;
    this.useKyuusyuuTicket = !this.useKyuusyuuTicket;
    return app.render();
  }

  toggleShowEx() {
    this.show_ex = !this.show_ex;
    this.showEx = !this.showEx;
    return app.render();
  }

  toggleEnableRentalcarForm() {
    this.enable_rentalcar_form = !this.enable_rentalcar_form;
    this.enableRentalcarForm = !this.enableRentalcarForm;
    return app.render();
  }

  toggleDayOffOperation() {
    this.dayOffOperation = !this.dayOffOperation;
    return app.render;
  }

  toggleEnableAutoStockCheck() {
    this.enableAutoStockCheck = !this.enableAutoStockCheck;
    return app.render;
  }

  toggleEnableBatchApproval() {
    this.enableBatchApproval = !this.enableBatchApproval;
    return app.render;
  }

  toggleUseSmartSearch() {
    this.use_smart_search = !this.use_smart_search;
    this.useSmartSearch = !this.useSmartSearch;
    return app.render();
  }

  setSelectedFreeeCompanyId(value) {
    this.selectedFreeeCompanyId = value;
    return app.render();
  }

  setExpediaType(value) {
    this.expediaType = value;
    return app.render();
  }

  expediaTypeEan() {
    return this.expediaType === 'ean';
  }

  expediaTypeEpsRapid() {
    return this.expediaType === 'eps_rapid';
  }

  setFreeePartnerId(value) {
    this.freeePartnerId = value || null;
    return app.render();
  }

  setFreeeMonthlyPriceSectionId(value) {
    this.freeeMonthlyPriceSectionId = value || null;
    return app.render();
  }

  setSalesforceId(value) {
    this.salesforceId = value;
    return app.render();
  }

  setSalesforceImportId(value) {
    this.salesforceImportId = value;
    return app.render();
  }

  setEnterpriseIdentifactionNumber(value) {
    this.enterpriseIdentifactionNumber = value;
    return app.render();
  }

  addBillReceiver() {
    const receiver = new OrganizationBillReceiver({ organization_id: this.id });
    this.organizationBillReceivers.push(receiver);
    return app.render();
  }

  removeBillReceiverAtIndex(index) {
    this.organizationBillReceivers.splice(index, 1);
    return app.render();
  }

  toggleSsoEnabled() {
    this.ssoEnabled = !this.ssoEnabled;
    return app.render();
  }

  setSsoEntityId(value) {
    this.ssoEntityId = value;
    return app.render();
  }

  setSsoUrl(value) {
    this.ssoUrl = value;
    return app.render();
  }

  setSsoLogoutUrl(value) {
    this.ssoLogoutUrl = value;
    return app.render();
  }

  setSsoIdpCertFile(file) {
    const reader = new FileReader();
    reader.onload = e => {
      this.ssoIdpCert = e.target.result;
      return app.render();
    };
    return reader.readAsDataURL(file);
  }

  submitParams() {
    const params = {
      name: this.name,
      domain: this.domain,
      url: this.url,
      amadeus_company_name: this.amadeus_company_name,
      address: this.address,
      tel: this.tel,
      person_in_charge_name: this.person_in_charge_name,
      person_in_charge_email: this.person_in_charge_email,
      billing_email: this.billing_email,
      bank_account_info: this.bank_account_info,
      agency_bank_account_info: this.agency_bank_account_info,
      show_fee: this.show_fee ? 1 : 0,
      include_tax: this.include_tax ? 1 : 0,
      use_bulk_ticket: this.use_bulk_ticket ? 1 : 0,
      use_kyuusyuu_ticket: this.use_kyuusyuu_ticket ? 1 : 0,
      margin_types_attributes: [this.domestic_margin_type.submitParams(), this.foreign_margin_type.submitParams()],
      show_ex: this.show_ex ? 1 : 0,
      plan_id: this.plan_id,
      rakuten_inner_fee_rate: this.rakuten_inner_fee_rate,
      exic_agency_fee_rate: this.exic_agency_fee_rate,
      revenue_reference_date_type: this.revenue_reference_date_type,
      orientation: this.orientation,
      expedia_type: this.expediaType,
      organization_bill_receivers_attributes: _.map(this.organizationBillReceivers, r => r.submitParams()),
      invoice_day: this.invoiceDay,
      request_form_approval_required: this.request_form_approval_required,
      enable_rentalcar_form: this.enable_rentalcar_form,
      day_off_operation: this.dayOffOperation,
      enable_auto_stock_check: this.enableAutoStockCheck,
      enable_batch_approval: this.enableBatchApproval,
      use_smart_search: this.useSmartSearch
    };
    if (this.arrangementRequestSetting) {
      params.arrangement_request_setting_attributes = this.arrangementRequestSetting.submitParams();
    }
    if (!_.isEmpty(this.salesforceId)) {
      params.salesforce_id = this.salesforceId;
    }
    if (!_.isEmpty(this.salesforceImportId)) {
      params.salesforce_import_id = this.salesforceImportId;
    }
    if (!_.isEmpty(this.enterpriseIdentifactionNumber)) {
      params.enterprise_identification_number = this.enterpriseIdentifactionNumber;
    }
    if (this.shinkansenLimitType) {
      params.shinkansen_limit_type_attributes = this.shinkansenLimitType.submitParams();
    }
    if (this.rentalCarLimitType) {
      params.rental_car_limit_type_attributes = this.rentalCarLimitType.submitParams();
    }
    if (this.packageLimitType) {
      params.package_limit_type_attributes = this.packageLimitType.submitParams();
    }
    return params;
  }
}
Organization.initClass();

module.exports = Organization;
